import PropTypes from 'prop-types';

import BeatingLoader from 'components/ui/BeatingLoader';

import * as svars from 'assets/style/variables';

function LoadingDataVisualization({ height, width }) {
  return (
    <BeatingLoader
      white
      style={{
        borderRadius: svars.borderRadius,
        height,
        width,
        margin: 'auto',
      }}
    />
  );
}

LoadingDataVisualization.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
LoadingDataVisualization.defaultProps = { width: '100%', height: '100%' };

export default LoadingDataVisualization;
